<template>
  <transition name="fade">
    <div
      v-if="value"
      class="toast d-flex align-start justify-space-between"
      :style="{ width: width, height: height }"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    width: {
      type: String,
      default: () => "100%",
    },
    height: {
      type: String,
      default: () => "100%",
    },
    infinite: {
      type: Boolean,
      default: () => false,
    },
    time: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => {
    return {};
  },
  watch: {
    value() {
      if (this.value) {
        if (!this.infinite) {
          setTimeout(() => {
            this.$emit("input", false);
          }, this.time);
        }
      }
    },
  },
  methods: {},
};
</script>

<style scoped>
.toast {
  position: relative;
  background-color: #ffffff;
  z-index: 10;
  box-shadow: -4px 4px 20px rgba(0, 0, 0, 0.1);
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
